import notFoundImageUrl from "@/assets/404.svg"
import { useAuthTokensAtom } from "@/data/store"
import { ROUTES } from "@/routes"
import { Link } from "react-router"
import HeroImage from "./HeroImage"
import Page from "./Page"

const PageNotFound = () => {
  const [authTokens] = useAuthTokensAtom()
  const homeRoute = authTokens ? ROUTES.DASHBOARD : ROUTES.SIGN_IN

  return (
    <Page>
      <HeroImage src={notFoundImageUrl} />
      <div className="flex flex-col items-center gap-3">
        <h1 className="text-center text-h1">404</h1>
        <p className="text-center text-h3">Page not found</p>
        <p className="text-center text-sm text-primary-contrast/70">
          The page you requested could not be found.
        </p>
        <Link
          to={homeRoute}
          className="mt-6 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-contrast hover:bg-primary/90"
        >
          {authTokens ? "Go to dashboard" : "Go to sign in"}
        </Link>
      </div>
    </Page>
  )
}

export default PageNotFound
